import { takeLatest, select, call, put } from 'redux-saga/effects'
import { GET_MY_RECORDS_USAGE, SET_MY_RECORDS_USAGE } from '../actions/type'
import { getHttpClient, getSelector, genVRoomToken } from '../../helpers'
import { showSpinner, hideSpinner } from '../actions/actions'
import { isEmpty } from 'lodash';

const keycloakSelector = getSelector('keycloak')

function* getMyRecordsUsage() {
  const keycloak = yield select(keycloakSelector)
  const url = `${window._env_.cloudRecordingApiBaseURL}/api/public/v1/cloud-records/usages`
  if (!isEmpty(keycloak)) {
    yield put(showSpinner)
    try {
      const token = yield call(genVRoomToken, keycloak)
      const response = yield call(getHttpClient, keycloak, url, { Authorization: "Bearer " + token })
      if (!isEmpty(response.data)) {
        yield put({
          type: SET_MY_RECORDS_USAGE,
          payload: response.data
        })
      }
    } catch (error) {
      console.error('myRecordsUsage', error)
    }
    yield put(hideSpinner)
  }
}

function* myRecordsUsageSaga() {
  yield takeLatest(GET_MY_RECORDS_USAGE, getMyRecordsUsage)
}

export default myRecordsUsageSaga